import styled from 'styled-components';

export const Wrapper = styled.div<{ zIndex: number; allowInteraction: boolean }>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  z-index: ${(p) => p.zIndex};
  pointer-events: ${(p) => (p.allowInteraction ? 'none' : 'auto')};
`;
